import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchDataActive, postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';



const BranchCreate = (props) => {


  const history = useHistory();

  const { isAuthenticated, clubId, userId, logout, token } = useAuth();
  const [branchcode, setBranchCode] = useState("");
  const [branchname, setBranchName] = useState("");
  const [ridistrict, setRIDistrict] = useState("");
  const [charterdate, setCharterDate] = useState("");
  const [idno, setIdNo] = useState("");
  const [email, setEmail] = useState("");
  const [meetingday, setMeetingDay] = useState("");
  const [meetingloc, setMeetingLocation] = useState("");
  const [meetingtime, setMeetingTime] = useState("");
  const [sponsoredby, setSponsoredBy] = useState("");
  const [location, setLocation] = useState("");
  const [postaladdress, setPostalAddress] = useState("");
  const [cashopening, setCashOpening] = useState("");
  const [website, setWebsite] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSave, setIsSave] = useState(false);


  const [insta, setInstaPage] = useState("");
  const [facebook, setFacebookPage] = useState("");
  const [spclub, setSponsoredClub] = useState("");



  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user

      logout();
      return;
    }

  }, [isAuthenticated, clubId, token, logout]);


  const clearForm = () => {
    // setEventName(""); setFromDate("");
    // setToDate(""); setDescription("");
    // setVenue(""); setIncomeEstimate("");
    // setExpenseEstimate(""); setIncomeActual("");
    // setExpenseActual("");

  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);
    submitData(e);

  }

  const submitData = async (e) => {
    e.preventDefault();



    const branch = {

      BranchCode: branchcode || "", // empty string instead of null
      Name: branchname || "",
      District: ridistrict || "",
      CharterDate: charterdate || "",
      IdNo: idno || "", // 0 instead of null for numbers
      Email: email || "",
      MeetingDay: null,
      meetingLoc: meetingloc || "",
      MeetingTime: null, // 0 instead of null for numbers
      ActualMeetingTime: meetingtime || "",
      SponsoredBy: sponsoredby || "",
      Location: location || "",
      PostalAddress: postaladdress || "",
      CashOpening: cashopening || 0, // 0 instead of null for numbers
      Website: website || 0,
      InstaLink: insta,
      FaceBookLink: facebook,
      CreatedBy: userId || "",
      CreatedDate: new Date(),
      ClubId: clubId || "",
      SposoredClub: spclub,
      MeetingDay1: meetingday,

    };




    try {
      const response = await postData('BranchApi/post-branch', branch, token);
      console.log('Club Created success:', response);
      setSuccessMessage("Club Created successfully!");
      setErrorMessage("");
      clearForm();

      setTimeout(() => {
        setSuccessMessage("");


      }, 3000);
      window.location.reload();
    } catch (error) {
      console.error('Club Create error:', error);
    }
  };


  return (
    <Fragment>
      <div className="w-full max-w-sm container mt-2 mx-auto">
        <form onSubmit={handleFormSubmit}>
          <div className="w-full flex justify-between items-center flex-wrap">
            {/* Heading on the left */}
            <h6 className='productHead linkcolor'
              style={{ color: 'black', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
              CLUB CREATE
            </h6>

            {/* Buttons on the right */}
            <div className="flex mt-2">
              <Button
                style={{
                  backgroundColor: '#5DB996',
                  color: 'white',
                  height: '36px',
                  marginTop: '15px'
                }}
                onClick={handleFormSubmit}
                className="linkcolor"
              >
                <span>Save</span>
              </Button>

              <Button
                className="linkcolor"
                onClick={() => history.push('/BIndex')}
                style={{
                  backgroundColor: '#FF748B',
                  color: 'white',
                  height: '36px',
                  marginTop: '15px',
                  marginLeft: '5px'
                }}>
                CANCEL
              </Button>
            </div>
          </div>
          <br></br>
          {errorMessage && <p className="text-red-500">{errorMessage}</p>}
          {successMessage && <p className="text-green-500">{successMessage}</p>}

          <div className="w-full flex flex-wrap">
            <div className="w-full sm:w-5/5 p-6 bg-white rounded-lg shadow-lg" style={{ width: '100%' }}>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="branchcode">Code</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={branchcode}
                    onChange={(e) => setBranchCode(e.target.value)}
                    type="text"
                    placeholder="Enter Code"
                  />
                </div>
                <div>
                  <label htmlFor="branchname">Name</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={branchname}
                    onChange={(e) => setBranchName(e.target.value)}
                    type="text"
                    placeholder="Enter Name"
                  />
                </div>
                <div>
                  <label htmlFor="ridistrict">RI District</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={ridistrict}
                    onChange={(e) => setRIDistrict(e.target.value)}
                    type="text"
                    placeholder="Enter District"
                  />
                </div>
                <div>
                  <label htmlFor="charterdate"> Date
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={charterdate}
                    onChange={(e) => setCharterDate(e.target.value)}
                    type="date"
                    placeholder="Select Charter Date"
                  />
                </div>
              </div>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="idno">ID No</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={idno}
                    onChange={(e) => setIdNo(e.target.value)}
                    type="text"
                    placeholder="Enter Id No"
                  />
                </div>
                <div>
                  <label htmlFor="location">Location</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    type="text"
                    placeholder="Enter Location"
                  />
                </div>

                <div>
                  <label htmlFor="meetingday" className="text-sm font-medium">Meeting Day</label>
                  <select
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="meetingday"
                    value={meetingday}
                    onChange={(e) => setMeetingDay(e.target.value)}
                  >
                    <option value="">Select a Day</option>
                    <option value="Sunday">Sunday</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="meetingloc">Meeting Location</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={meetingloc}
                    onChange={(e) => setMeetingLocation(e.target.value)}
                    type="text"
                    placeholder="Enter Meeting Location"
                  />
                </div>
              </div>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="meetingtime">Meeting Time</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    name="meetingtime"
                    value={meetingtime}  // Ensure it's an empty string if undefined
                    onChange={(e) => setMeetingTime(e.target.value)}
                    type="time"  // 'time' picker will send the format as HH:mm
                    placeholder="Select Meeting Time"
                  />
                </div>

                <div>
                  <label htmlFor="email">Email</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="text"
                    placeholder="Enter Email"
                  />
                </div>
                <div>
                  <label htmlFor="postaladdress">Postal Address</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={postaladdress}
                    onChange={(e) => setPostalAddress(e.target.value)}
                    type="text"
                    placeholder="Enter Postal Address"
                  />
                </div>
                <div>
                  <label htmlFor="website">Website</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                    type="text"
                    placeholder="Enter Website"
                  />
                </div>
              </div>


              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="gstno">Insta Page</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={insta}
                    onChange={(e) => setInstaPage(e.target.value)}
                    type="text"
                    placeholder="Enter Insta Page"
                  />
                </div>
                <div>
                  <label htmlFor="panno">Facebook Page</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={facebook}
                    onChange={(e) => setFacebookPage(e.target.value)}
                    type="text"
                    placeholder="Enter Facebook Page"
                  />
                </div>
                <div>
                  <label htmlFor="location">Sponsored Club</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={spclub}
                    onChange={(e) => setSponsoredClub(e.target.value)}
                    type="text"
                    placeholder="Enter Sponsored Club"
                  />
                </div>
                <div>
                  <label htmlFor="pincode">Sponsored by this Club</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={sponsoredby}
                    onChange={(e) => setSponsoredBy(e.target.value)}
                    type="text"
                    placeholder="Enter Sponsored by this Club"
                  />
                </div>
              </div>
              <div className="w-full grid grid-cols-4 gap-2">
                <div>
                  <label htmlFor="cashopening">Cash Opening</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight text-right focus:text-gray-600 focus:shadow-outline"
                    value={cashopening}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9.]/g, ""); // Allows numbers and decimal
                      const validNumber = numericValue.match(/^\d*\.?\d{0,2}$/) ? numericValue : cashopening;
                      setCashOpening(validNumber);
                    }}
                    type="text"
                    placeholder="Enter Cash Opening"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
}

export default BranchCreate;




